import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// Fetch coupon settings
export const fetchCouponSetting = createAsyncThunk(
  "couponSetting/fetchCouponSetting",
  async (_, { rejectWithValue }) => {
    try {
      // console.log("Fetching coupon settings...");

      const response = await axios.get(`${BASE_URL}/couponSetting`);
      // console.log(response);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch coupon settings"
      );
    }
  }
);

// Update coupon settings
export const updateCouponSetting = createAsyncThunk(
  "couponSetting/updateCouponSetting",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.put(`${BASE_URL}/couponSetting`, data, {
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      return response.data.data || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update coupon settings"
      );
    }
  }
);

// Toggle coupon status (PATCH)
export const toggleCouponSettingStatus = createAsyncThunk(
  "couponSetting/toggleCouponSettingStatus",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.patch(`${BASE_URL}/couponSetting`, null, {
        headers: { token },
      });

      return response.data.data || response.data;
    } catch (error) {
      console.error(
        "Toggle status failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to toggle coupon status"
      );
    }
  }
);

// Slice definition
const couponSlice = createSlice({
  name: "couponSetting",
  initialState: {
    couponSetting: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetCouponState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔸 Fetch
      .addCase(fetchCouponSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCouponSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.couponSetting = action.payload;
      })
      .addCase(fetchCouponSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔸 Update
      .addCase(updateCouponSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateCouponSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.couponSetting = action.payload;
      })
      .addCase(updateCouponSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      // 🔸 Toggle status
      .addCase(toggleCouponSettingStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(toggleCouponSettingStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.couponSetting = action.payload;
      })
      .addCase(toggleCouponSettingStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetCouponState } = couponSlice.actions;
export default couponSlice.reducer;
